import "./ContactSec5.css";

export const ContactSec5 = () => {
  const countries = [
    "Algeria","Angola","Botswana","Burkina Faso","Burundi","Benin","Cameroon","Central African Republic","Comoros",
    "Congo","DR Congo","Ghana","Guinea","Gabon","India","Ivory Coast","Kenya","Liberia",
    "Madagascar","Mali","Malawi","Mozambique","Namibia","Nigeria","Qatar","Rwanda","Saudi Arabia",
    "Senegal","Sierra Leone","South Africa","Tanzania","Togo","UAE","Uganda","Zambia","Zimbabwe"
  ];

  return (
    <div className="contactsec5 standard-padding">
      <h2 className="heading mb-4">
        Serving Clients Across 35+ Countries
      </h2>

      <div className="contactsec5-grid">
        {countries.map((country, index) => (
          <p key={index} className="contactsec5-item">
           {country}
          </p>
        ))}
      </div>
    </div>
  );
};